import script from "./FieldGroup.vue?vue&type=script&lang=ts"
export * from "./FieldGroup.vue?vue&type=script&lang=ts"

import "./field-group.scss?vue&type=style&index=0&lang=scss"

export default script